import { useState, useEffect } from 'react';
import { AdvertisingStatus, JobStatus } from '../data/enums/jobEnums';
import { getWithExpiry, setWithExpiry } from '../utils/sessionStorage';

const JOBS_PAGE_DATA_KEY = 'jobsPageData';
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

// Check for cached jobs data to initialize with
const getCachedInitialValues = () => {
  const cachedJobsData = getWithExpiry(JOBS_PAGE_DATA_KEY);
  if (cachedJobsData?.filters) {
    console.log('🔄 Using cached values for jobs page:', cachedJobsData.filters);
    return {
      selectedStatus: cachedJobsData.filters.selectedStatus || JobStatus.OPEN,
      searchTerm: cachedJobsData.filters.searchTerm || '',
      advertisingStatusFilter: cachedJobsData.filters.advertisingStatusFilter || AdvertisingStatus.ALL,
    };
  }
  return {
    selectedStatus: JobStatus.OPEN,
    searchTerm: '',
    advertisingStatusFilter: AdvertisingStatus.ALL,
  };
};

const initialCachedValues = getCachedInitialValues();

const persistentState = {
  selectedStatus: initialCachedValues.selectedStatus,
  searchTerm: initialCachedValues.searchTerm,
  advertisingStatusFilter: initialCachedValues.advertisingStatusFilter,
};

// purpose: to provide a good ux, we save filter state
export const usePersistedJobsState = () => {
  const [selectedStatus, setSelectedStatus] = useState<JobStatus>(persistentState.selectedStatus);
  const [searchTerm, setSearchTerm] = useState<string>(persistentState.searchTerm);
  const [advertisingStatusFilter, setAdvertisingStatusFilter] = useState<AdvertisingStatus>(
    persistentState.advertisingStatusFilter
  );

  // Actually persist to sessionStorage when state changes
  useEffect(() => {
    persistentState.selectedStatus = selectedStatus;
    persistentState.searchTerm = searchTerm;
    persistentState.advertisingStatusFilter = advertisingStatusFilter;
    
    // Write to sessionStorage
    setWithExpiry(JOBS_PAGE_DATA_KEY, {
      filters: {
        selectedStatus,
        searchTerm,
        advertisingStatusFilter,
      }
    }, CACHE_TTL);
  }, [selectedStatus, searchTerm, advertisingStatusFilter]);

  return {
    selectedStatus,
    setSelectedStatus,
    searchTerm,
    setSearchTerm,
    advertisingStatusFilter,
    setAdvertisingStatusFilter,
  };
};